import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectInput from '../../../common/inputs/select-input';
import { withEditSpot } from '../../../../../spots/hoc/withEditSpot';

var CodeTypeKeys = {
  UNIVERSAL: { value: 'universal', text: 'Universal Code' },
  WORDPRESS: { value: 'wordpress', text: 'WordPress' },
  DEFAULT: { value: -1, text: 'Select platform...' }
};

function getPlatform(value) {
  var platform = null;
  switch (value) {
    case 'wordpress':
      platform = CodeTypeKeys.WORDPRESS;
      break;
    case 'universal':
      platform = CodeTypeKeys.UNIVERSAL;
      break;
    default:
      platform = CodeTypeKeys.DEFAULT;
  }
  return platform;
}

class PlatformInput extends Component {
  constructor(props, context) {
    super(props, context);
    var platform = getPlatform(props.value);
    this.state = {
      error: 'Please select',
      success: null,
      platform
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value && nextProps.value !== -1) {
      var platform = getPlatform(nextProps.value);
      this.setState({
        platform,
        success: true,
        error: null
      });
    }
  }

  handlePlatformChange(platform) {
    this.setState({
      platform,
      error: null,
      success: true
    });
    if (this.props.autoSave) {
      this.props.editSpot(this.props.spotId, { platform: platform.value });
    }
  }

  getValue() {
    return this.state.platform && this.state.platform.value;
  }

  isValid() {
    return !!this.state.success;
  }

  render() {
    var value = this.state.platform ? this.state.platform : CodeTypeKeys.DEFAULT;
    var validate = this.props.validate;
    return (
      <div className="platform-selection">
        <SelectInput
          title="Platform"
          description="Select your site's programming platform."
          onChange={this.handlePlatformChange.bind(this)}
          options={[CodeTypeKeys.UNIVERSAL, CodeTypeKeys.WORDPRESS]}
          error={validate && this.state.error}
          success={validate && this.state.success}
          value={value}
        />
      </div>
    );
  }
}

PlatformInput.propTypes = {
  value: PropTypes.oneOf(['universal', 'wordpress']),
  validate: PropTypes.bool,
  autoSave: PropTypes.bool,
  spotId: PropTypes.string
};

PlatformInput.displayName = 'PlatformInput';

export default withEditSpot(PlatformInput);
